import React, { createContext, useContext, useMemo, useState } from 'react';

const LanguageContext = createContext();

const translations = {
  tr: {
    nav: {
      landing: 'Landing',
      about: 'Hakkimizda',
      home: 'Anasayfa',
      search: 'Arama',
      messages: 'Mesajlar',
      profile: 'Profil',
      support: 'Destek',
    },
    actions: {
      login: 'Giris',
      register: 'Kayit',
      logout: 'Cikis',
      startNow: 'Hemen Basla',
      goFeed: "Anasayfa'ya Git",
      update: 'Guncelle',
      save: 'Kaydet',
      send: 'Gonder',
      share: 'Paylas',
      sharePost: 'Gonderiyi Paylas',
      createPost: 'Gonderi Olustur',
      loadMore: 'Daha Fazla',
      friendRequest: 'Arkadaslik Istegi Gonder',
      details: 'Detay',
      close: 'Kapat',
    },
    support: {
      title: 'Destek',
      subtitle: 'Sorun, istek veya geri bildiriminizi iletin.',
      name: 'Ad',
      email: 'E-posta',
      subject: 'Konu',
      message: 'Mesaj',
      success: 'Mesajiniz alindi, en kisa surede size donus yapacagiz.',
      error: 'Mesaj gonderilemedi. Lutfen tekrar deneyin.',
      required: 'Mesaj alanı zorunludur.',
    },
    common: {
      loading: 'Yukleniyor...',
      fileSent: 'Dosya gonderildi.',
      chatFallback: 'Sohbet',
    },
    landing: {
      heroTitle: 'Antrenmanlarini sosyal bir ritme donustur.',
      heroDesc:
        'Aphel; feed, mesajlar, antrenman planlari ve paylasimlari tek bir ritimde birlestirir.',
      featureFeedTitle: 'Antrenman Feedi',
      featureFeedDesc: 'Video ve gorsellerle antrenmanlarini paylas, toplulugun nabzini hisset.',
      featureChatTitle: 'Gercek Zamanli Mesaj',
      featureChatDesc: 'Takim arkadaslarinla hizli sohbet et, birlikte ilerleyin.',
      featurePlanTitle: 'Planlarini Netlestir',
      featurePlanDesc: 'Haftalik antrenman plani olustur, programini tek ekranda gor.',
    },
    auth: {
      loginTitle: 'Giris Yap',
      loginDesc: 'Antrenmanlarini kaldigin yerden devam ettir.',
      registerTitle: 'Kayit Ol',
      registerDesc: 'Profilini olustur ve antrenmanlarini paylas.',
      email: 'Email',
      password: 'Sifre',
      name: 'Isim',
      surname: 'Soyisim',
      username: 'Kullanici adi',
      gender: 'Cinsiyet',
      age: 'Yas',
      height: 'Boy (cm)',
      weight: 'Kilo (kg)',
      photo: 'Profil fotografi',
      terms: "Kullanim kosullari ve EULA'yi kabul ediyorum.",
      loginError: 'Giris basarisiz.',
      registerError: 'Kayit basarisiz.',
      updateError: 'Profil guncellenemedi.',
    },
    feed: {
      title: 'Anasayfa',
      subtitle: 'Bugun ne paylasiyorsun?',
      description: 'Aciklama',
      media: 'Medya',
      mediaTab: 'Medya',
      textTab: 'Yazi',
      textLabel: 'Yazi',
      like: 'Begen',
      liked: 'Begenildi',
      likes: 'begeni',
      textPosts: 'Yazili Gonderiler',
      commentPlaceholder: 'Yorum yaz...',
      addComment: 'Yorum Yap',
      shareLabel: 'Paylas',
      errorLoad: 'Anasayfa yuklenemedi.',
      errorMissing: 'Aciklama ve medya secmelisin.',
      errorShare: 'Gonderi paylasilamadi.',
      errorTextEmpty: 'Yazi bos olamaz.',
      errorTextShare: 'Yazili gonderi paylasilamadi.',
      errorLike: 'Begenme islemi yapilamadi.',
    },
    profile: {
      title: 'Profil',
      edit: 'Profili Duzenle',
      updateDesc: 'Bilgilerini guncelleyip kaydet.',
      currentPlan: 'Guncel Program',
      posts: 'Gonderilerim',
      postsUser: 'Gonderiler',
      info: 'Bilgiler',
      email: 'Email',
      heightWeight: 'Boy / Kilo',
      emptyDay: 'Bos gun',
      noProgram: 'Program bilgisi bulunamadi.',
    },
    search: {
      title: 'Arama',
      subtitle: 'Kullanici adi, isim ya da soyisimle ara.',
      placeholder: 'Kullanici ara...',
      empty: 'Kullanici bulunamadi.',
    },
    messages: {
      title: 'Mesajlar',
      subtitle: 'Sohbetlerini buradan yonet.',
      placeholder: 'Mesaj yaz...',
      loading: 'Yukleniyor...',
      fileSent: 'Dosya gonderildi.',
      chatFallback: 'Sohbet',
    },
    about: {
      title: 'Hakkimizda',
      mission: 'Misyon',
      vision: 'Vizyon',
      features: 'Neler Sunuyoruz?',
      body:
        'Aphel, spor yapanlari ayni ekosistemde bulusturmak icin tasarlanmis bir sosyal fitness platformu. Paylasim, plan ve topluluk - hepsi tek yerde.',
      missionText: 'Her antrenmani bir topluluk deneyimine donusturmek.',
      visionText:
        'Global bir fitness ritmi yaratmak ve herkesin kendi yolculugunu gosterebilmesini saglamak.',
      featuresList: [
        'Gorsel ve video paylasimlariyla akilli feed',
        'Gercek zamanli mesajlasma ve paylasilan gonderiler',
        'Haftalik antrenman planlama',
        'Arkadaslik, yakin arkadas ve bildirim sistemi',
      ],
      tags: ['Topluluk', 'Performans', 'Motivasyon'],
    },
    post: {
      detail: 'Gonderi Detayi',
      back: 'Geri',
      comments: 'Yorumlar',
      notFound: 'Gonderi bulunamadi.',
      you: '@sen',
    },
    footer: {
      tagline: 'Sosyal antrenman ritmini kur.',
    },
    mobileCta: {
      title: 'Simdi mobil uygulamamizi indirin',
      subtitle: 'Aphel deneyimini iOS ve Android cihazinda kesintisiz yasayin.',
      appStore: 'App Store',
      playStore: 'Google Play',
    },
  },
  en: {
    nav: {
      landing: 'Landing',
      about: 'About',
      home: 'Home',
      search: 'Search',
      messages: 'Messages',
      profile: 'Profile',
      support: 'Support',
    },
    actions: {
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      startNow: 'Start Now',
      goFeed: 'Go to Feed',
      update: 'Update',
      save: 'Save',
      send: 'Send',
      share: 'Share',
      sharePost: 'Share post',
      createPost: 'Create post',
      loadMore: 'Load More',
      friendRequest: 'Send friend request',
      details: 'Details',
      close: 'Close',
    },
    support: {
      title: 'Support',
      subtitle: 'Send your issue, request, or feedback.',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      success: 'We received your message and will get back to you soon.',
      error: 'Could not send your message. Please try again.',
      required: 'Message is required.',
    },
    common: {
      loading: 'Loading...',
      fileSent: 'File sent.',
      chatFallback: 'Chat',
    },
    landing: {
      heroTitle: 'Turn your training into a social rhythm.',
      heroDesc:
        'Aphel blends feed, messaging, training plans, and sharing into a single flow.',
      featureFeedTitle: 'Training feed',
      featureFeedDesc: 'Share workouts with photos and videos, feel the community pulse.',
      featureChatTitle: 'Real-time messages',
      featureChatDesc: 'Move faster with your team and keep the momentum together.',
      featurePlanTitle: 'Clarify your plan',
      featurePlanDesc: 'Build weekly training plans and see everything at a glance.',
    },
    auth: {
      loginTitle: 'Log in',
      loginDesc: 'Pick up your training where you left off.',
      registerTitle: 'Create account',
      registerDesc: 'Build your profile and share your training.',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      surname: 'Surname',
      username: 'Username',
      gender: 'Gender',
      age: 'Age',
      height: 'Height (cm)',
      weight: 'Weight (kg)',
      photo: 'Profile photo',
      terms: 'I accept the terms of service and EULA.',
      loginError: 'Login failed.',
      registerError: 'Registration failed.',
      updateError: 'Profile update failed.',
    },
    feed: {
      title: 'Feed',
      subtitle: 'What are you sharing today?',
      description: 'Description',
      media: 'Media',
      mediaTab: 'Media',
      textTab: 'Text',
      textLabel: 'Text',
      like: 'Like',
      liked: 'Liked',
      likes: 'likes',
      textPosts: 'Text Posts',
      commentPlaceholder: 'Write a comment...',
      addComment: 'Add comment',
      shareLabel: 'Share',
      errorLoad: 'Feed failed to load.',
      errorMissing: 'Please add a description and media.',
      errorShare: 'Post could not be shared.',
      errorTextEmpty: 'Text cannot be empty.',
      errorTextShare: 'Text post could not be shared.',
      errorLike: 'Like action failed.',
    },
    profile: {
      title: 'Profile',
      edit: 'Edit profile',
      updateDesc: 'Update your details and save.',
      currentPlan: 'Current plan',
      posts: 'My posts',
      postsUser: 'Posts',
      info: 'Info',
      email: 'Email',
      heightWeight: 'Height / Weight',
      emptyDay: 'Rest day',
      noProgram: 'No plan found.',
    },
    search: {
      title: 'Search',
      subtitle: 'Search by username, name, or surname.',
      placeholder: 'Search users...',
      empty: 'No users found.',
    },
    messages: {
      title: 'Messages',
      subtitle: 'Manage your conversations here.',
      placeholder: 'Write a message...',
      loading: 'Loading...',
      fileSent: 'File sent.',
      chatFallback: 'Chat',
    },
    about: {
      title: 'About',
      mission: 'Mission',
      vision: 'Vision',
      features: 'What we offer',
      body:
        'Aphel is a social fitness platform designed to bring athletes into one ecosystem. Sharing, planning, and community - all in one place.',
      missionText: 'Turn every workout into a community experience.',
      visionText:
        'Create a global fitness rhythm and help everyone show their own journey.',
      featuresList: [
        'Smart feed with photo and video posts',
        'Real-time messaging and shared posts',
        'Weekly training planning',
        'Friends, close friends, and notification system',
      ],
      tags: ['Community', 'Performance', 'Motivation'],
    },
    post: {
      detail: 'Post Detail',
      back: 'Back',
      comments: 'Comments',
      notFound: 'Post not found.',
      you: '@you',
    },
    footer: {
      tagline: 'Build your social training loop.',
    },
    mobileCta: {
      title: 'Download the mobile app now',
      subtitle: 'Experience Aphel on iOS and Android with full features.',
      appStore: 'App Store',
      playStore: 'Google Play',
    },
  },
};

const detectLanguage = () => {
  const browserLang = navigator.language?.slice(0, 2).toLowerCase();
  return translations[browserLang] ? browserLang : 'en';
};

export const LanguageProvider = ({ children }) => {
  const stored = localStorage.getItem('lang');
  const [language, setLanguageState] = useState(stored || detectLanguage());

  const setLanguage = (value) => {
    setLanguageState(value);
    localStorage.setItem('lang', value);
  };

  const t = useMemo(() => {
    return (key) => {
      const parts = key.split('.');
      let cur = translations[language] || translations.en;
      for (const part of parts) {
        if (!cur || typeof cur !== 'object' || !(part in cur)) {
          return key;
        }
        cur = cur[part];
      }
      return cur;
    };
  }, [language]);

  return (
    <LanguageContext.Provider
      value={{
        t,
        language,
        setLanguage,
        availableLanguages: Object.keys(translations),
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
